import { faShieldCheck } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { PageHeader } from "../../../../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../../../../shared/components/pageHeader/PageHeaderApi"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../../shared/components/links/StandardBreadcrumbs"
import { SUPPORT_ADMIN_ROUTE } from "../../../../../../constants/routes"
import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"
import { StandardTabs } from "../../../../../../shared/components/tabs/StandardTabs"
import { AydenSummary } from "../components/summary/AydenSummary"
import { AccountHolders } from "../components/accountHolders/AccountHolders"

export function SupportAdyen() {
    const { l10n } = useAppLocalization()

    const tabs = [
        { label: l10n.getString("support-reports-health-adyen-tab-summary"), component: <AydenSummary /> },
        {
            label: l10n.getString("support-reports-health-adyen-tab-account-holders"),
            component: <AccountHolders />,
        },
    ]

    return (
        <>
            <LocalizedStrict id="support-reports-health-adyen-page-header" attrs={{ title: true }}>
                <PageHeader
                    page={Page.SUPPORT_ADMIN_HEALTH_ADYEN}
                    title="Adyen"
                    icon={<FontAwesomeIcon icon={faShieldCheck} />}
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="support-nav-item-home">
                            <BreadcrumbLink to={SUPPORT_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="support-nav-item-health">
                            <Breadcrumb>Health</Breadcrumb>
                        </LocalizedStrict>
                        <LocalizedStrict id="support-nav-item-health-adyen">
                            <Breadcrumb>Adyen</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>
            <StandardTabs tabs={tabs} />
        </>
    )
}
